import styled from "styled-components";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { baseUrl } from "../config";
import { DateIRLToErache } from "../utils/dateConverters";
import { FaSortUp, FaSortDown } from "react-icons/fa";
import { Table, ListContainer } from "./styles";
import PeriodsList from "./PeriodsList";
import DetailDrawer from "./DetailDrawer";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

const MePeriods = () => {
  const [openDetail, setOpenDetail] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "startDate", direction: "asc" });
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);

  // Prevent out-of-order responses overwriting a newer page.
  const fetchSeqRef = useRef(0);
  const fetchMyPeriods = async (
    pageIndex = 0,
    pageSize = 20,
    sortKey = "startDate",
    sortDirection = "asc",
    columnFilters = []
  ) => {
    const fetchSeq = ++fetchSeqRef.current;
    try {
      const params = {
        page: pageIndex + 1,
        pageSize,
        sortKey,
        sortDirection,
        validOnly: "false",
      };
      columnFilters.forEach((f) => {
        params[f.id] = f.value;
      });
      params.authorPseudo = "me";
      const response = await axios.get(baseUrl + "/periods", {
        withCredentials: true,
        params,
      });
      // Ignore stale responses.
      if (fetchSeq !== fetchSeqRef.current) return;
      setPeriods(response.data.data || []);
      setRowCount(response.data.total || 0);
    } catch (err) {
      console.error("Error fetching my periods:", err);
    }
  };

  useEffect(() => {
    fetchMyPeriods(
      pagination.pageIndex,
      pagination.pageSize,
      sortConfig.key,
      sortConfig.direction,
      columnFilters
    );
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sortConfig.key,
    sortConfig.direction,
    columnFilters,
  ]);

  const requestSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });
  };

  const refetchPeriods = () => {
    fetchMyPeriods(pagination.pageIndex, pagination.pageSize, sortConfig.key, sortConfig.direction, columnFilters);
  };

  return (
    <MePeriodsContainer>
      <h1>Liste des périodes que vous avez créées</h1>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        component={Link}
        to="/add-period"
        sx={{ alignSelf: "flex-start", mb: 2 }}
      >
        Créer une période
      </Button>
      <PeriodsList
        fetchPeriods={fetchMyPeriods}
        periods={periods}
        pagination={pagination}
        setPagination={setPagination}
        rowCount={rowCount}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        requestSort={requestSort}
        sortConfig={sortConfig}
        setSortConfig={setSortConfig}
        DateIRLToErache={DateIRLToErache}
        FaSortUp={FaSortUp}
        FaSortDown={FaSortDown}
        ListContainer={ListContainer}
        Table={Table}
        onOpenEventDetail={(id) => setOpenDetail({ type: "event", id })}
        onOpenPeriodDetail={(id) => setOpenDetail({ type: "period", id })}
      />
      <DetailDrawer
        open={openDetail}
        onClose={() => setOpenDetail(null)}
        onOpenDetail={setOpenDetail}
        onEventDeleted={refetchPeriods}
        onPeriodDeleted={refetchPeriods}
        DateIRLToErache={DateIRLToErache}
      />
    </MePeriodsContainer>
  );
};

export default MePeriods;

const MePeriodsContainer = styled(ListContainer)`
  max-width: 100vw;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
`;
